import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GlobalLogic } from '../../shared/logic/global-logic';
import '../styles/text-box.scss';
import { isEnter } from '../../shared/util/functions';

library.add(faPlusCircle);
library.add(faMinusCircle);

interface Props {
    bgColor: string;
    fontSize: number;
    text: string;
    onFontSizeChange: (decrease?: boolean) => void;
    fontColor: string;
    fontFamily: string;
}

export const TextBox: React.FunctionComponent<Props> = props => {

    const globalLogic = GlobalLogic.getInstance();

    return (
        <div className={'text-box--wrapper'}>
			<div
                tabIndex={0}
                aria-label={'verkleinern'}
				className={'text-box-icon text-box__minus'}
				onKeyPress={evt => isEnter(evt) && props.onFontSizeChange(true)}
				onClick={() => props.onFontSizeChange(true)}>
				<FontAwesomeIcon icon={'minus-circle'}/>
			</div>
            <div className={'text-box'} style={{ backgroundColor: props.bgColor }}>
				<span
                    className={'text-box__text'}
                    style={{
                        fontFamily: props.fontFamily,
                        fontSize: props.fontSize * globalLogic.scaleFactor + 'pt',
                        color: props.fontColor
                    }}
                >
					{props.text}
				</span>
            </div>
            <div tabIndex={0}
                 aria-label={'vergrößern'}
				 className={'text-box-icon text-box__plus'}
				 onKeyPress={evt => isEnter(evt) && props.onFontSizeChange()}
				 onClick={() => props.onFontSizeChange()}>
				<FontAwesomeIcon icon={'plus-circle'}/>
			</div>
        </div>
    );
};
